export enum FareType {
  'Basic' = 'Basic',
  'Flexible' = 'Flexible',
  'Ranged_Flexible' = 'Ranged_Flexible',
  'Zonal' = 'Zonal',
  'Dynamic' = 'Dynamic',
  'Custom' = 'Custom',
}
